import styled, { css } from 'styled-components';
import { themed } from '@/shared/ui/core';

export const Wrapper = styled.div.attrs({
  className: 'MultiSelect',
})`
`;

export const SelectButton = styled.button.attrs({
  type: 'button',
})`
  background-color: ${themed('primary.background')};
  border: solid ${themed('input.borderWidth')} ${themed('common.borderColor')};
  border-radius: 3px;
  color: ${themed('primary.darkGray')}99;
  cursor: pointer;
  font-size: ${themed('input.fontSize')};
  height: 2.75rem;
  line-height: 2.75rem;
  overflow: hidden;
  padding: 0 1.25rem 0 0.75rem;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  z-index: 1;

  > span {
    color: ${themed('primary.darkGray')};
    font-size: 0.625rem;
    left: 0.8125rem;
    opacity: 0;
    position: absolute;
    text-transform: uppercase;
    transform: translateY(-0.5rem);
    transition: all 100ms ease-in-out;
  }

  svg {
    height: 1rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;

    path {
      fill: ${themed('primary.darkGray')};
    }

    &.check {
      path {
        fill: ${themed('status.success')};
      }
    }

    &.chevron {
      height: 0.625rem;
      right: 0.5rem;
      width: 0.625rem;
    }
  }

  ${({ hasSelection }) => hasSelection && css`
    color: ${themed('primary.text')};
    line-height: unset;
    padding: 0.95rem 0.25rem 0 0.75rem;

    > span {
      opacity: 1;
      transform: translateY(-0.875rem);
    }

    > svg.check, svg.chevron {
      display: none;
    }
  `};
`;

export const Backdrop = styled.div`
  display: none;

  @media(max-width: 480px) {
    background-color: rgba(0 0 0 / 20%);
    display: block;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
  }
`;

export const SelectOptions = styled.div.attrs({
  className: 'SelectOptions',
})`
  background-color: ${themed('primary.background')};
  border: solid ${themed('input.borderWidth')} ${themed('common.borderColor')};
  box-shadow: 0 0 8px -4px rgba(0, 0, 0, 0.75);
  position: absolute;
  right: ${({ $alignRight }) => $alignRight ? 0 : 'unset'};
  z-index: 2;
  max-width: 100%;

  ul {
    margin: 0;
    max-height: ${({ $height }) => $height ?? 180}px;
    overflow: auto;
    padding: 0.25rem 0;
    width: ${({ $width }) => $width ? `${$width}px` : 'auto'};
    max-width: 100%;

    li {
      list-style: none;
    }
  }

  @media(max-width: 480px) {
    border: none;
    border-radius: 0.3rem;
    left: 50%;
    max-height: calc(100vh - 6rem);
    overflow: hidden;
    position: fixed;
    right: unset;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 101;
    max-width: 90%;

    ul {
      max-height: calc(100vh - 6rem);
      padding-bottom: 3rem;
      width: calc(100vw - 2.5rem);

      li {
        button {
          font-size: 1rem;
          height: 2.5rem;
          padding: 0 1rem;
        }

        & + li {
          border-top: 1px solid ${themed('primary.lightGray')};
        }
      }
    }
  }
`;

export const SelectOption = styled.button.attrs({
  type: 'button',
})`
  background-color: ${themed('primary.background')};
  border: none;
  cursor: pointer;
  font-size: ${themed('input.fontSize')};
  height: 1.75rem;
  padding: 0 0.5rem;
  position: relative;
  text-align: left;
  width: 100%;

  &:hover {
    background-color: ${themed('primary.lightBlue')}30;
  }

  ${({ selected }) => selected && css`
    text-decoration: underline;
  `};

  svg {
    height: 0.875rem;
    padding: 2px;
    position: absolute;
    right: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.875rem;

    path {
      fill: ${themed('primary.accent')};
    }
  }
`;

export const Actions = styled.div`
  background-color: ${themed('primary.background')};
  border-top: 1px solid ${themed('primary.gray')};
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: 100%;

  @media(min-width: 481px) {
    display: none;
  }
`;

export const ActionButton = styled.button`
  background-color: ${themed('primary.background')};
  border: none;
  color: ${themed('primary.accent')};
  font-size: ${themed('input.fontSize')};
  font-weight: 500;
  height: 3rem;
  padding: 0 1rem;
  text-transform: uppercase;

  &:last-of-type {
    padding-right: 2rem;
  }
`;
